// @flow

import { background } from '../stylesheets/background.css'

type colorHandlerTypeProps = {
  backgroundColor: string
}

export const colorComponent = {
  type: 'color',
  render(id: string, props: colorHandlerTypeProps, bgInnerHTML: ?string = ''): string {
    const { backgroundColor } = props
    const style = `background-color: ${backgroundColor};`

    return `
      <div id="${id}" class="${background}" style="${style}">
        ${bgInnerHTML}
      </div>
    `
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/color.js